"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toMongoUpdate = exports.patch = exports.diff = void 0;
const meta = require("./meta");
const pointer = require("./pointer");
/*
export function toDottedPath(path: string): string {
  return (path || '').split('/').slice(1).join('.');
}
*/
function diff(src, dst, path = '/') {
    let out = [];
    if (src !== dst) {
        if (typeof src !== 'undefined' && typeof dst === 'undefined') {
            return [{ op: 'remove', path }];
        }
        else if (typeof src === 'undefined' && typeof dst !== 'undefined') {
            return [{ op: 'add', path, value: dst }];
        }
        else if (typeof src !== typeof dst || src === null || dst === null || typeof src !== 'object') {
            return [{ op: 'replace', path, value: dst }];
        }
        else if (Array.isArray(src) !== Array.isArray(dst)) {
            return [{ op: 'replace', path, value: dst }];
        }
        else if (Array.isArray(src)) {
            for (let i = 0, max = Math.min(src.length, dst.length); i < max; i++) {
                out = out.concat(diff(src[i], dst[i], `${path === '/' ? '' : path}/${i}`));
            }
            if (src.length > dst.length) {
                for (let i = dst.length; i < src.length; i++) {
                    out.push({ op: 'remove', path: `${path === '/' ? '' : path}/${i}` });
                }
            }
            else if (src.length < dst.length) {
                for (let i = src.length; i < dst.length; i++) {
                    out.push({ op: 'add', path: `${path === '/' ? '' : path}/-`, value: dst[i] });
                }
            }
        }
        else {
            const keys = new Set([...Object.keys(src), ...Object.keys(dst)]);
            for (let k of keys) {
                out = out.concat(diff(src[k], dst[k], `${path === '/' ? '' : path}/${k}`));
            }
        }
    }
    return out;
}
exports.diff = diff;
function patch(obj, patch) {
    const out = meta.annotate(JSON.parse(JSON.stringify(obj)), { scope: 'jsonref:patch' });
    for (let p of patch) {
        const path = (p.path || '').split('/').slice(1);
        if (!path.length) {
            throw new Error('path cannot be empty');
        }
        const key = path.pop();
        const parent = path.length ? pointer.resolve(out, `/${path.join('/')}`) : out;
        if (typeof parent !== 'object') {
            throw new Error('parent is non-object');
        }
        switch (p.op) {
            case 'add':
                if (key === '-') {
                    if (!Array.isArray(parent)) {
                        throw new Error("cannot use '-' index on non-array");
                    }
                    parent.push(p.value);
                }
                else {
                    if (parent[key]) {
                        throw new Error('cannot add, path exists');
                    }
                    parent[key] = p.value;
                }
                break;
            case 'replace':
                if (key === '-') {
                    throw new Error("cannot use '-' index in path of replace");
                }
                if (!parent[key]) {
                    throw new Error('cannot replace, path does not exist');
                }
                parent[key] = p.value;
                break;
            case 'move':
                {
                    const from = (p.from || '').split('/').slice(1);
                    if (!from.length) {
                        throw new Error('from path cannot be empty');
                    }
                    const fromKey = from.pop();
                    if (fromKey === '-') {
                        throw new Error("cannot use '-' index in from path of move");
                    }
                    const fromParent = from.length ? pointer.resolve(out, `/${from.join('/')}`) : out;
                    if (!fromParent[fromKey]) {
                        throw new Error('cannot move, from path does not exist');
                    }
                    if (key === '-') {
                        if (!Array.isArray(parent)) {
                            throw new Error("cannot use '-' index on non-array");
                        }
                        parent.push(fromParent[fromKey]);
                    }
                    else {
                        parent[key] = fromParent[fromKey];
                    }
                    if (Array.isArray(fromParent)) {
                        fromParent.splice(parseInt(fromKey), 1);
                    }
                    else {
                        delete fromParent[fromKey];
                    }
                }
                break;
            case 'remove':
                if (key === '-') {
                    throw new Error("cannot use '-' index in path of remove");
                }
                else if (!parent[key]) {
                    throw new Error('cannot remove, path does not exist');
                }
                if (Array.isArray(parent)) {
                    parent.splice(parseInt(key), 1);
                }
                else {
                    delete parent[key];
                }
                break;
            case 'copy':
                {
                    const from = (p.from || '').split('/').slice(1);
                    if (!from.length) {
                        throw new Error('from path cannot be empty');
                    }
                    const fromKey = from.pop();
                    if (fromKey === '-') {
                        throw new Error("cannot use '-' index in from path of copy");
                    }
                    const fromParent = from.length ? pointer.resolve(out, `/${from.join('/')}`) : out;
                    if (!fromParent[fromKey]) {
                        throw new Error('cannot move, from path does not exist');
                    }
                    if (key === '-') {
                        if (!Array.isArray(parent)) {
                            throw new Error("cannot use '-' index on non-array");
                        }
                        parent.push(fromParent[fromKey]);
                    }
                    else {
                        parent[key] = fromParent[fromKey];
                    }
                }
                break;
            case 'test':
                if (key === '-') {
                    throw new Error("cannot use '-' index in path of test");
                }
                if (parent[key] !== p.value) {
                    throw new Error('test failed');
                }
                break;
        }
    }
    return JSON.parse(JSON.stringify(out));
}
exports.patch = patch;
function toMongoUpdate(patch) {
    const out = {};
    for (let p of patch) {
        const path = (p.path || '').split('/').slice(1);
        if (!path.length) {
            throw new Error('path cannot be empty');
        }
        switch (p.op) {
            case 'add':
                if (!out.doc)
                    out.doc = {};
                if (path.length && path[path.length - 1] == '-') {
                    if (path.length === 1) {
                        throw new Error("cannot use '-' index at root of path");
                    }
                    path.pop();
                    if (!out.doc.$push)
                        out.doc.$push = {};
                    out.doc.$push[path.join('.')] = p.value;
                }
                else {
                    if (!out.doc.$set)
                        out.doc.$set = {};
                    out.doc.$set[path.join('.')] = p.value;
                }
                break;
            case 'replace':
                if (path.length && path[path.length - 1] == '-') {
                    throw new Error("cannot use '-' index in path of replace");
                }
                else {
                    if (!out.doc)
                        out.doc = {};
                    if (!out.doc.$set)
                        out.doc.$set = {};
                    out.doc.$set[path.join('.')] = p.value;
                    if (!out.query)
                        out.query = {};
                    out.query[path.join('.')] = { $exists: true };
                }
                break;
            case 'move':
                const from = (p.from || '').split('/').slice(1);
                if (!from.length) {
                    throw new Error('from path cannot be empty');
                }
                if (from.length && from[from.length - 1] == '-') {
                    throw new Error("cannot use '-' index in from path of move");
                }
                else if (path.length && path[path.length - 1] == '-') {
                    throw new Error("cannot use '-' index in path of move");
                }
                else {
                    if (!out.doc)
                        out.doc = {};
                    if (!out.doc.$rename)
                        out.doc.$rename = {};
                    out.doc.$rename[from.join('.')] = path.join('.');
                }
                break;
            case 'remove':
                if (path.length && path[path.length - 1] == '-') {
                    throw new Error("cannot use '-' index in path of remove");
                }
                else {
                    if (!out.doc)
                        out.doc = {};
                    if (!out.doc.$unset)
                        out.doc.$unset = {};
                    out.doc.$unset[path.join('.')] = 1;
                }
                break;
            case 'copy':
                throw new Error('copy not supported');
            case 'test':
                if (path.length && path[path.length - 1] == '-') {
                    throw new Error("cannot use '-' index in path of test");
                }
                else {
                    if (!out.query)
                        out.query = {};
                    out.query[path.join('.')] = p.value;
                }
                break;
        }
    }
    return out;
}
exports.toMongoUpdate = toMongoUpdate;
//# sourceMappingURL=patch.js.map